import React from 'react';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import {
  Row,
  Col,
  Card,
  Form,
  Input,
  Select,
  Button,
  Divider,
  Tag,
} from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import SubPageLayout from '../helpers/SubPageLayout';

const { Option } = Select;

// Simulated customer / order data per project
const customerByProjectCode = {
  'PRJ-001': {
    mafqNumber: 'MAQ1001',
    industry: 'MineSAFE',
    mafNumber: 'MAF1236',
    date: '2025-06-01',
    customer: 'Assmang',
    country: 'South Africa',
    siteName: 'Black Rock',
    contact: 'Humbelani Phunge',
    contactNumber: '073 061 2710',
    salesPerson: 'Duane Mac Farlane',
    sapIndustryCode: '15 Capital MASA',
    poNumber: '2400041604CE',
    paymentTerms: 'Net 30',
    fabricator: 'Vomak',
    shippingTerms: 'Delivery To Site MineARC',
    noOfUnits: '1 of 1',
    qaLevel: 'Level 3',
    surfaceTreatment: 'Standard',
    projectNumber: 'P463',
  },
};

const PreBuild = () => {
  //const { code: projectCode, productId } = useParams();
  const location = useLocation();
  const history = useHistory();

  // 👇 this comes from history.push('/pre-build', { product, projectCode })
  const { product, projectCode } = location.state || {};

 // const product = location.state?.product || null;

  const customer =
    customerByProjectCode[projectCode] ||
    {
      mafqNumber: '',
      industry: '',
      mafNumber: product?.serialNumber || '',
      date: '',
      customer: '',
      country: '',
      siteName: '',
      contact: '',
      contactNumber: '',
      salesPerson: '',
      sapIndustryCode: '',
      poNumber: '',
      paymentTerms: '',
      fabricator: '',
      shippingTerms: '',
      noOfUnits: '',
      qaLevel: '',
      surfaceTreatment: '',
      projectNumber: '',
    };

  const initialValues = {
    mafqNumber: customer.mafqNumber,
    industry: customer.industry,
    mafNumber: customer.mafNumber,
    date: customer.date,
    customer: customer.customer,
    country: customer.country,
    siteName: customer.siteName,
    contact: customer.contact,
    contactNumber: customer.contactNumber,
    salesPerson: customer.salesPerson,
    sapIndustryCode: customer.sapIndustryCode,

    structure: 'Modular',
    standardsApplicable: 'WA Guidelines',
    scrubber: 'Series 4',
    modelNumber: 'MS-SDC-30-SIV-36',
    occupancy: '30 PERSON',
    duration: '36',

    itHitch: '',
    insulation: '',
    airLock: '',
    fireResistance: '',
    reinforcedSkids: '',
    blastResistance: '',
    blastRating: '',
    boggerFrame: '',
    wheelAndTow: '',
    supsUpgrade: '',

    cams: 'YES',
    transformer: 'V',
    externalGasMonitoring: 'GuardIAN Promo',
    ppms: '',
    internalLcdScreen: '',
    firstAidKitQty: '',
    maceyPlug: '',
    spinalBoard: '',
    gasTubeO2: 'O2',
    gasTubeCO2: 'CO2',
    gasTubeCO: 'CO',
    oxygenFitting: 'Bull Nose-Male',
    o2Candle: 'YES',
    manualsLanguage: 'English',
    decalsLanguage: 'English',

    guardian: 'YES',
    guardianConnect: '',
    ipAddress: '',
    connectionMethod: '',
    cameraQty: '1',
    externalCameraQty: '',
    phone: 'Yes',
    custom1: '',
    custom2: '',

    poNumber: customer.poNumber,
    paymentTerms: customer.paymentTerms,
    invoiceNumber: '',
    depositReceived: '',
    fabricator: customer.fabricator,
    shippingTerms: customer.shippingTerms,
    noOfUnits: customer.noOfUnits,
    containerSizeCheck: '',
    ceCertification: '',
    otherCertification: '',

    dimensions: '',
    surfaceTreatment: customer.surfaceTreatment,
    projectNumber: customer.projectNumber,
    estimatedWeight: 'Per DRG',
    qaqcLevel: customer.qaLevel,
    fabPaintCost: '',
  };

  return (
    <SubPageLayout
      title={`Pre-Build${product ? ` - ${product.productName}` : ''}`}
      extra={
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={() => history.goBack()}
        >
          Back
        </Button>
      }
    >
      {/* Top summary banner */}
      <Card
        style={{
          marginBottom: 16,
          borderRadius: 16,
          boxShadow: '0 10px 30px rgba(15,23,42,0.08)',
        }}
        bodyStyle={{ padding: 20 }}
      >
        <Row gutter={16} align="middle">
          <Col xs={24} md={16}>
            <div style={{ marginBottom: 4, fontSize: 13, color: '#6b7280' }}>
              Order: <strong>{projectCode}</strong>
            </div>
            <div
              style={{
                fontSize: 20,
                fontWeight: 600,
                color: '#111827',
                marginBottom: 6,
                display: 'flex',
                flexWrap: 'wrap',
                gap: 8,
                alignItems: 'center',
              }}
            >
              {product?.productName || 'Product'}
              {product?.serialNumber && (
                <Tag color="blue" style={{ marginLeft: 4 }}>
                  {product.serialNumber}
                </Tag>
              )}
            </div>
            <div
              style={{
                fontSize: 13,
                color: '#6b7280',
                display: 'flex',
                flexWrap: 'wrap',
                gap: 12,
              }}
            >
              {customer.customer && (
                <span>
                  Customer:{' '}
                  <strong style={{ color: '#111827' }}>
                    {customer.customer}
                  </strong>
                </span>
              )}
              {customer.siteName && (
                <span>
                  Site:{' '}
                  <strong style={{ color: '#111827' }}>
                    {customer.siteName}
                  </strong>
                </span>
              )}
              {customer.country && (
                <span>
                  Country:{' '}
                  <strong style={{ color: '#111827' }}>
                    {customer.country}
                  </strong>
                </span>
              )}
            </div>
          </Col>
          <Col xs={24} md={8}>
            <div
              style={{
                borderRadius: 14,
                background:
                  'linear-gradient(135deg,#eff6ff 0%,#e0f2fe 45%,#f9fafb 100%)',
                padding: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  width: 140,
                  height: 140,
                  borderRadius: 12,
                  overflow: 'hidden',
                  background: '#e5e7eb',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {product?.image ? (
                  <img
                    src={product.image}
                    alt={product.productName}
                    style={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      objectFit: 'contain',
                      display: 'block',
                    }}
                  />
                ) : (
                  <span style={{ fontSize: 12, color: '#9ca3af' }}>
                    No image
                  </span>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Card>

      {/* Main form layout */}
      <Form
        layout="vertical"
        initialValues={initialValues}
        style={{ maxWidth: 1200 }}
      >
        {/* Customer Information */}
        <Card
          title="Customer Information"
          size="small"
          style={{ marginBottom: 16, borderRadius: 16 }}
        >
          <Row gutter={16}>
            <Col xs={24} md={8}>
              <Form.Item label="MAFQ # (Quote)" name="mafqNumber">
                <Input placeholder="e.g. MAQ1001" />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item label="Industry" name="industry">
                <Input placeholder="e.g. MineSAFE" />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item label="MAF #" name="mafNumber">
                <Input placeholder="e.g. 476" />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* Customer and Sales Information */}
        <Card
          title="Customer and Sales Information"
          size="small"
          style={{ marginBottom: 16, borderRadius: 16 }}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item label="Date" name="date">
                <Input placeholder="YYYY-MM-DD" />
              </Form.Item>
              <Form.Item label="Customer" name="customer">
                <Input placeholder="Customer name" />
              </Form.Item>
              <Form.Item label="Country" name="country">
                <Input placeholder="Country" />
              </Form.Item>
              <Form.Item label="Site Name" name="siteName">
                <Input placeholder="Site name" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item label="Contact" name="contact">
                <Input placeholder="Contact person" />
              </Form.Item>
              <Form.Item label="Contact #" name="contactNumber">
                <Input placeholder="Phone number" />
              </Form.Item>
              <Form.Item label="Sales Person (BDM)" name="salesPerson">
                <Input placeholder="Sales person" />
              </Form.Item>
              <Form.Item label="SAP Industry Code #" name="sapIndustryCode">
                <Input placeholder="e.g. 15 Capital MASA" />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* Refuge Information and Upgrades */}
        <Card
          title="Refuge Information and Upgrades"
          size="small"
          style={{ marginBottom: 16, borderRadius: 16 }}
        >
          <Row gutter={16}>
            <Col xs={24} md={6}>
              <Form.Item label="Structure" name="structure">
                <Input placeholder="e.g. Modular" />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Scrubber" name="scrubber">
                <Input placeholder="e.g. Series 4" />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Occupancy" name="occupancy">
                <Input placeholder="e.g. 30 PERSON" />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Duration (hours)" name="duration">
                <Input placeholder="e.g. 36" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={8}>
              <Form.Item label="Standards Applicable" name="standardsApplicable">
                <Input placeholder="e.g. WA Guidelines" />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item label="Model Number" name="modelNumber">
                <Input placeholder="e.g. MS-SDC-30-SIV-36" />
              </Form.Item>
            </Col>
          </Row>

          <Divider orientation="left" style={{ marginTop: 8 }}>
            Upgrades
          </Divider>

          <Row gutter={16}>
            <Col xs={24} md={6}>
              <Form.Item label="IT Hitch" name="itHitch">
                <Input />
              </Form.Item>
              <Form.Item label="Insulation" name="insulation">
                <Input />
              </Form.Item>
              <Form.Item label="Air Lock" name="airLock">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Fire Resistance" name="fireResistance">
                <Input />
              </Form.Item>
              <Form.Item label="Reinforced Skids" name="reinforcedSkids">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Blast Resistance" name="blastResistance">
                <Input />
              </Form.Item>
              <Form.Item label="Blast Rating" name="blastRating">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Bogger Frame" name="boggerFrame">
                <Input />
              </Form.Item>
              <Form.Item label="Wheel & Tow" name="wheelAndTow">
                <Input />
              </Form.Item>
              <Form.Item label="SUPS Upgrade" name="supsUpgrade">
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* Component Options */}
        <Card
          title="Component Options"
          size="small"
          style={{ marginBottom: 16, borderRadius: 16 }}
        >
          <Row gutter={16}>
            <Col xs={24} md={6}>
              <Form.Item label="CAMS" name="cams">
                <Input />
              </Form.Item>
              <Form.Item label="AODS" name="aods">
                <Input />
              </Form.Item>
              <Form.Item label="PPMS" name="ppms">
                <Input />
              </Form.Item>
              <Form.Item label="COSOS" name="csos">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Transformer" name="transformer">
                <Input />
              </Form.Item>
              <Form.Item
                label="External Gas Monitoring"
                name="externalGasMonitoring"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Internal LCD Screen" name="internalLcdScreen">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Macey Plug" name="maceyPlug">
                <Input />
              </Form.Item>
              <Form.Item label="Gas Tubes" style={{ marginBottom: 4 }}>
                <Input.Group compact>
                  <Form.Item name="gasTubeO2" noStyle>
                    <Input style={{ width: '33%' }} placeholder="O2" />
                  </Form.Item>
                  <Form.Item name="gasTubeCO2" noStyle>
                    <Input style={{ width: '33%' }} placeholder="CO2" />
                  </Form.Item>
                  <Form.Item name="gasTubeCO" noStyle>
                    <Input style={{ width: '34%' }} placeholder="CO" />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
              <Form.Item label="Oxygen Fitting" name="oxygenFitting">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="O2 Candle" name="o2Candle">
                <Input />
              </Form.Item>
              <Form.Item label="First Aid Kit Qty" name="firstAidKitQty">
                <Input />
              </Form.Item>
              <Form.Item label="Spinal Board" name="spinalBoard">
                <Input />
              </Form.Item>
              <Form.Item label="Manuals / Decal Languages">
                <Input.Group compact>
                  <Form.Item name="manualsLanguage" noStyle>
                    <Input style={{ width: '50%' }} placeholder="Manuals" />
                  </Form.Item>
                  <Form.Item name="decalsLanguage" noStyle>
                    <Input style={{ width: '50%' }} placeholder="Decals" />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* GuardIAN Setup / Remote Monitoring */}
        <Card
          title="GuardIAN Setup / Remote Monitoring Requirements"
          size="small"
          style={{ marginBottom: 16, borderRadius: 16 }}
        >
          <Row gutter={16}>
            <Col xs={24} md={6}>
              <Form.Item label="GuardIAN" name="guardian">
                <Input placeholder="YES / NO" />
              </Form.Item>
              <Form.Item label="GuardIAN Connect" name="guardianConnect">
                <Input />
              </Form.Item>
              <Form.Item label="IP Address" name="ipAddress">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Connection Method" name="connectionMethod">
                <Input />
              </Form.Item>
              <Form.Item label="Camera Qty" name="cameraQty">
                <Input />
              </Form.Item>
              <Form.Item
                label="External Camera Qty"
                name="externalCameraQty"
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Phone" name="phone">
                <Input placeholder="Yes / No" />
              </Form.Item>
              <Form.Item label="Custom Additional 1" name="custom1">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Custom Additional 2" name="custom2">
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* Sales and Shipping Information */}
        <Card
          title="Sales and Shipping Information"
          size="small"
          style={{ marginBottom: 16, borderRadius: 16 }}
        >
          <Row gutter={16}>
            <Col xs={24} md={6}>
              <Form.Item label="PO #" name="poNumber">
                <Input placeholder="e.g. 2400041604CE" />
              </Form.Item>
              <Form.Item label="Invoice #" name="invoiceNumber">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Payment Terms" name="paymentTerms">
                <Input placeholder="e.g. Net 30" />
              </Form.Item>
              <Form.Item label="Deposit Received" name="depositReceived">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Fabricator" name="fabricator">
                <Input />
              </Form.Item>
              <Form.Item label="Shipping Terms" name="shippingTerms">
                <Input placeholder="e.g. Delivery To Site MineARC" />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="No. of Units" name="noOfUnits">
                <Input />
              </Form.Item>
              <Form.Item label="Container size check" name="containerSizeCheck">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} md={6}>
              <Form.Item label="CE Certification" name="ceCertification">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Other Certification" name="otherCertification">
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* Fabrication and Paint */}
        <Card
          title="Fabrication and Paint"
          size="small"
          style={{ marginBottom: 24, borderRadius: 16 }}
        >
          <Row gutter={16}>
            <Col xs={24} md={6}>
              <Form.Item label="Dimensions" name="dimensions">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Surface Treatment" name="surfaceTreatment">
                <Input placeholder="e.g. Standard" />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Project #" name="projectNumber">
                <Input placeholder="e.g. P463" />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Estimated Weight" name="estimatedWeight">
                <Input placeholder="e.g. Per DRG" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} md={6}>
              <Form.Item label="QAQC Level" name="qaqcLevel">
                <Input placeholder="e.g. Level 3" />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Cost (Fab & Paint)" name="fabPaintCost">
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* Action bar (can be wired later) */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 8,
            marginBottom: 40,
          }}
        >
          <Button onClick={() => history.goBack()}>Cancel</Button>
          <Button type="primary">
            Save Pre-Build
          </Button>
        </div>
      </Form>
    </SubPageLayout>
  );
};

export default PreBuild;
